export default function (editor) {
  const getTooltipText = (alignment: string) => {
    const tooltips = {
      left: "Left",
      center: "Center",
      right: "Right",
      justify: "Justify",
    };
    return tooltips[alignment] || "Justify";
  };

  editor.ui.registry.addSplitButton("alignment", {
    tooltip: "Justify",
    icon: "align-left",
    columns: 4,
    fetch: function (callback) {
      callback([
        { type: "choiceitem", icon: "align-left", value: "left" },
        { type: "choiceitem", icon: "align-center", value: "center" },
        { type: "choiceitem", icon: "align-right", value: "right" },
        { type: "choiceitem", icon: "align-justify", value: "justify" },
      ]);
    },
    onAction: function () {
      editor.execCommand("justifyLeft");
    },
    onItemAction: function (buttonApi, value) {
      const alignment = value === "justify" ? "full" : value;
      editor.execCommand(`justify${alignment}`);
      // Update icon immediately after selection
      if (buttonApi) {
        buttonApi.setIcon(`align-${value}`);
        buttonApi.setTooltip(getTooltipText(value));
      }
    },
    select: function (value) {
      const node = editor.selection.getNode();
      const parent = editor.dom.getParent(node, "[style*='text-align']");
      return editor.dom.getStyle(parent, "textAlign") === value;
    },
    onSetup: function (buttonApi) {
      const nodeChangeHandler = function (eventApi) {
        buttonApi.setActive(
          eventApi.parents.some((parent) => {
            return !!editor.dom.getStyle(parent, "textAlign");
          }),
        );
        // Update icon based on current alignment
        const node = editor.selection.getNode();
        const parent = editor.dom.getParent(node, "[style*='text-align']");
        const currentAlignment = editor.dom.getStyle(parent, "textAlign") || "left";
        buttonApi.setIcon(`align-${currentAlignment}`);
        buttonApi.setTooltip(getTooltipText(currentAlignment));
      };
      editor.on("NodeChange", nodeChangeHandler);
      return function () {
        return editor.off("NodeChange", nodeChangeHandler);
      };
    },
  });
}
